import { Button } from '@kanda-libs/ks-design-library';
import type { OpenBankingInfoPopoverProps } from '..';
import OpenBankingInfoMobileModal from './Modal';
import useOptionPopoverMobile from './useOptionPopoverMobile';

const OpenBankingInfoPopoverMobile: React.FunctionComponent<OpenBankingInfoPopoverProps> =
  function ({ children }) {
    const { onClick } = useOptionPopoverMobile();
    return (
      <>
        <Button.Icon
          id="open-banking-info"
          onClick={onClick}
          icon="info"
          iconProps={{
            className: 'w-4 cursor-pointer min-w-4 text-neutral-500 ml-2',
            size: 16,
            stroke: 'neutral-500',
          }}
          className="my-auto"
        />
        <OpenBankingInfoMobileModal>{children}</OpenBankingInfoMobileModal>
      </>
    );
  };

export default OpenBankingInfoPopoverMobile;
